export default __webpack_public_path__ + "static/media/Private-5g_Customer-Story-Industrial.c893b9fd.jpg";